<template>
  <div class="form-element">
    <div class="form-element__policy">
      <input
        type="checkbox"
        :id="text"
        :name="text"
        @change="changed"
        v-model="val"
      />
      <label :class="classObject" :for="text">
        <svg
          v-if="val"
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="10"
          viewBox="0 0 12 10"
        >
          <g
            fill="none"
            fill-rule="evenodd"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <g stroke="#13A2E8" stroke-width="2">
              <g>
                <g>
                  <path
                    d="M1 5.232L4.046 8.53 11 1"
                    transform="translate(-506 -580) translate(470 197) translate(36 383)"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
      </label>
      <div class="form-element__policy__text"><slot></slot></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: null,
    },
    isError: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      val: this.value,
    };
  },
  computed: {
    text: function () {
      let _random = Math.floor(Math.random() * 999999) + 1;

      return `checkbox-${_random}`;
    },
    classObject: function () {
      let list = {
        "-error": this.isError,
      };

      return list;
    },
  },
  watch: {
    value: function (val) {
      this.val = val;
    },
  },
  methods: {
    changed: function (e) {
      this.$emit("input", e.target.checked);

      return e.target.checked;
    },
  },
};
</script>